import { useNavigate } from "react-router-dom";
import { AlertTriangle, ArrowLeft, Users, School } from "lucide-react";

const ErrorCommonEvalEmptyClass = ({ niveau, error }) => {
  const navigate = useNavigate();

  // Extraire les noms des classes depuis l'erreur
  const extractClassNames = (errorMessage) => {
    if (!errorMessage) return [];
    const match = errorMessage.match(/: (.+)\.$/);
    if (match && match[1]) {
      return match[1].split(", ").map(name => name.trim());
    }
    return [];
  };

  const classesVides = extractClassNames(error);

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-red-100 overflow-hidden">
        {/* Header avec gradient */}
        <div className="bg-gradient-to-r from-red-500 to-orange-500 px-6 py-5 xl:px-4 xl:py-3 2xl:px-5 2xl:py-4 3xl:px-6 3xl:py-5">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white/20 backdrop-blur-sm rounded-xl">
              <AlertTriangle className="w-6 h-6 xl:w-4 xl:h-4 2xl:w-5 2xl:h-5 3xl:w-6 3xl:h-6 text-white" />
            </div>
            <div>
              <h2 className="text-xl xl:text-base 2xl:text-lg 3xl:text-xl font-bold text-white">
                Création impossible
              </h2>
              <p className="text-white/80 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">
                Devoir commun niveau {niveau}ème
              </p>
            </div>
          </div>
        </div>

        {/* Contenu */}
        <div className="p-6 xl:p-3 2xl:p-4 3xl:p-6">
          {/* Message principal */}
          <div className="flex items-start gap-3 mb-5">
            <div className="p-2 bg-amber-100 rounded-lg flex-shrink-0">
              <Users className="w-5 h-5 xl:w-4 xl:h-4 3xl:w-5 3xl:h-5 text-amber-600" />
            </div>
            <div>
              <p className="text-gray-800 font-medium mb-1 xl:text-xs 2xl:text-sm 3xl:text-base">
                Classes sans élèves détectées
              </p>
              <p className="text-gray-600 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">
                Certaines classes du niveau {niveau}ème n'ont aucun élève enregistré.
                Vous devez d'abord ajouter des élèves avant de créer un devoir commun.
              </p>
            </div>
          </div>

          {/* Liste des classes vides */}
          {classesVides.length > 0 && (
            <div className="bg-red-50 border border-red-200 rounded-xl p-4 xl:p-2 2xl:p-3 3xl:p-4 mb-5">
              <div className="flex items-center gap-2 mb-3">
                <School className="w-4 h-4 text-red-600" />
                <span className="font-medium text-red-800 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">
                  {classesVides.length} classe{classesVides.length > 1 ? 's' : ''} concernée{classesVides.length > 1 ? 's' : ''}
                </span>
              </div>
              <div className="flex flex-wrap gap-2">
                {classesVides.map((classe, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center px-3 py-1.5 bg-white border border-red-200 rounded-lg text-sm xl:text-xs 2xl:text-xs 3xl:text-sm font-medium text-red-700"
                  >
                    {classe}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Info */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 xl:p-2 2xl:p-3 3xl:p-4 mb-6 xl:mb-3 2xl:mb-4 3xl:mb-6">
            <p className="text-blue-800 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">
              <span className="font-semibold">Comment faire ?</span> Demandez au chef d'établissement
              d'importer les élèves, ou ajoutez-les manuellement depuis l'espace classe.
            </p>
          </div>

          {/* Bouton retour */}
          <button
            onClick={() => navigate(-1)}
            className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-amber-600
                       text-white font-semibold px-6 py-3 xl:px-4 xl:py-2 2xl:px-5 2xl:py-2.5 3xl:px-6 3xl:py-3 rounded-xl xl:text-sm 2xl:text-sm 3xl:text-base
                       shadow-lg hover:shadow-xl transform hover:scale-[1.02]
                       transition-all duration-200"
          >
            <ArrowLeft className="w-5 h-5 xl:w-4 xl:h-4 3xl:w-5 3xl:h-5" />
            Retour à la sélection
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorCommonEvalEmptyClass;
